export default "__VITE_ASSET__CXCKMhUm__"